import type { IUser } from "src/model/model";

export const buildNextPreferences = (
  currentPrefs: unknown,
  want: boolean,
): Record<string, unknown> => {
  let base: Record<string, unknown> = {};
  try {
    if (typeof currentPrefs === "string") {
      base = JSON.parse(currentPrefs) ?? {};
    } else if (typeof currentPrefs === "object" && currentPrefs !== null) {
      base = { ...(currentPrefs as Record<string, unknown>) };
    }
  } catch {
    base = {};
  }
  return { ...base, wantToReceiveEmailAboutReleases: !!want };
};

export const getReleaseOptIn = (u?: IUser): boolean => {
  const pref = (u as any)?.preferences;
  if (!pref) return false;
  try {
    // if someone accidentally stored a JSON string, recover gracefully
    const obj = typeof pref === "string" ? JSON.parse(pref) : pref;
    return !!obj?.wantToReceiveEmailAboutReleases;
  } catch {
    return false;
  }
};
